import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useGlobalContext } from "../../context";
import { useLocation, Link } from "react-router-dom";
import FadeOnScreen from "../../utils/fadeOnScreen";
import { Button } from "../../components";
import localData from "../../localData";

export default function About() {
    const { fade } = useGlobalContext().animations;

    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => FadeOnScreen.createObserver(), [location]);

    const { whatWeDoIcon, aboutCover } = localData.images;
    const { kobo, seed, prive, lh, farms, mvx, contactUs } = localData.images;
    return (
        <motion.main {...fade} className="about-page">
            <section className="showcase" data-lazy-block>
                <div className="container info-container">
                    <div className="col col-1">
                        <div className="showcase-icon">
                            <img src={whatWeDoIcon} alt="" />
                        </div>
                        <div className="showcase-title-wrapper">
                            <h2 className="showcase-title display-1">Find clarity in chaos</h2>
                        </div>
                        <p className="showcase-description">
                            At Mowida, we approach marketing with a growth mindset and a strong focus on emerging brands
                            and start-ups. We listen, learn and understand before we build. Together, we identify your
                            goals, help you find your ideal consumer, and thrive in a VUCA landscape. From strategic
                            marketing solutions to innovative product design &amp; memorable campaigns, we help our
                            clients grow, innovate, transform and find that sweet spot of simple and impactful.
                        </p>
                        <div className="wrapper">
                            <Link to="/contact">
                                <Button className="btn btn-lg btn-outline-light contact-btn">
                                    <p>start a conversation</p>
                                </Button>
                            </Link>
                        </div>
                    </div>
                    <div className="col col-2">
                        <div className="showcase-cover">
                            <img src={aboutCover} alt="" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="sponsors" data-lazy-block>
                <div className="container-1050">
                    <div className="sponsors-center">
                        <div className="item">
                            <img className="kobo" src={kobo} alt="" />
                        </div>
                        <div className="item">
                            <img src={mvx} alt="" />
                        </div>
                        <div className="item">
                            <img src={farms} alt="" />
                        </div>
                        <div className="item">
                            <img src={lh} alt="" />
                        </div>
                        <div className="item">
                            <img src={prive} alt="" />
                        </div>
                        <div className="item">
                            <img className="seed" src={seed} alt="" />
                        </div>
                    </div>
                </div>
            </section>
        </motion.main>
    );
}
